export default "__VITE_ASSET__9SypOgbP__"